import axios from 'src/adapters/axios';
import { IS_INTERNAL_ORIGIN, uri } from 'src/config';
import { BusinessReviewEntryType, } from 'src/function-utils/data-models';
import { MAX_REVIEWS_TO_SHOW, REVIEWS_FETCH_PER_PAGE, } from 'src/function-utils/shared-config';
import { get, writable } from 'svelte/store';
import { floatingWidgetSettingsStore } from '../floating-widget-settings-store';
export const bizReviewStore = writable({
    data: [],
    displayData: [],
    loading: false,
});
let fetchedAllReviews = false;
let limitDisplayReviews = false;
let LIMIT_DISPLAY_REVIEW_COUNT = 5;
floatingWidgetSettingsStore.subscribe((widgetSettings) => {
    var _a;
    limitDisplayReviews =
        !IS_INTERNAL_ORIGIN && ((_a = widgetSettings.gates) === null || _a === void 0 ? void 0 : _a.limitDisplayReviews);
    updateStoreData();
});
export function getBizReviews(businessKey) {
    if (fetchedAllReviews) {
        return;
    }
    return fetchReviews(businessKey, getReviewsLength());
}
async function fetchReviews(businessKey, start = 0) {
    if (!businessKey) {
        console.error('Biz reviews store: missing business key');
        return;
    }
    if (isLoading())
        return;
    setLoading(true);
    try {
        const res = await axios.get(uri.bizReviews, {
            params: { 'business-key': businessKey, start },
        });
        updateStoreData(res.data);
        if (res.data.data.length < REVIEWS_FETCH_PER_PAGE ||
            getReviewsLength() >= MAX_REVIEWS_TO_SHOW) {
            fetchedAllReviews = true;
        }
    }
    catch (e) {
        console.log(e);
    }
    setLoading(false);
}
/**
 * Updates the store
 */
function updateStoreData(newPage) {
    bizReviewStore.update((currentPage) => {
        const newDataList = [...currentPage.data, ...((newPage === null || newPage === void 0 ? void 0 : newPage.data) || [])];
        const displayData = getDisplayReviews(newDataList);
        const page = newPage !== null && newPage !== void 0 ? newPage : currentPage;
        const after = newDataList.length === displayData.length ? page.after : null;
        return Object.assign(Object.assign({}, page), { data: newDataList, displayData,
            after, loading: false });
    });
}
/**
 * Gets length of reviews.
 */
function getReviewsLength() {
    return get(bizReviewStore).data.length;
}
/**
 * Gets loading status.
 */
function isLoading() {
    return !!get(bizReviewStore).loading;
}
/**
 * Sets loading status.
 */
function setLoading(loading) {
    bizReviewStore.update((currentPage) => {
        return Object.assign(Object.assign({}, currentPage), { loading });
    });
}
/**
 * Gets list of reviews meant to be displayed.
 */
function getDisplayReviews(reviews) {
    if (!reviews.length)
        return [];
    if (reviews.length <= LIMIT_DISPLAY_REVIEW_COUNT) {
        return reviews;
    }
    if (limitDisplayReviews) {
        const reviewsToDisplay = reviews.slice(0, LIMIT_DISPLAY_REVIEW_COUNT);
        const lastEntry = reviewsToDisplay[LIMIT_DISPLAY_REVIEW_COUNT - 1];
        const replaceLastEntry = (lastEntry === null || lastEntry === void 0 ? void 0 : lastEntry.type) !== BusinessReviewEntryType.RAVELY_VIDEO;
        return [
            ...(replaceLastEntry ? reviewsToDisplay.slice(0, -1) : reviewsToDisplay),
            Object.assign(Object.assign({ id: -1, message: '' }, (replaceLastEntry ? lastEntry : {})), { type: BusinessReviewEntryType.SEE_ALL }),
        ];
    }
    return reviews;
}
